import api from "./api";

const semesterService = {
  getAllSemesters: async (params = {}) => {
    const response = await api.get("/api/college/semesters", { params });
    return response.data.data || response.data;
  },

  getSemesterById: async (id) => {
    const response = await api.get(`/api/college/semesters/${id}`);
    return response.data.data || response.data;
  },

  createSemester: async (data) => {
    const response = await api.post("/api/college/semesters", data);
    return response.data.data || response.data;
  },

  updateSemester: async (id, data) => {
    const response = await api.put(`/api/college/semesters/${id}`, data);
    return response.data.data || response.data;
  },

  deleteSemester: async (id) => {
    const response = await api.delete(`/api/college/semesters/${id}`);
    return response.data.data || response.data;
  },
};

export default semesterService;
